import store from './store';
import NoteList from './components/NoteList';
import Vue from 'vue';

export default function(entityType, entityId, options) {
  options = Object.assign({
    recentFirst: false,
    comments: false,
  }, options);
  new Vue({
    el: '.notes-list',
    render: h => h(NoteList, {props: {
      entityType,
      entityId,
      recentFirst: options.recentFirst,
      commentsMode: options.commentsMode,
    }}),
    store,
  });
  store.dispatch('loadNotes', {
    entityType,
    entityId,
  });
};



// WEBPACK FOOTER //
// ./assets/js/notes.js